/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { OutputReport2 } from './output-report-2';

export class FirmwareSizeMessage extends OutputReport2 {

    public constructor() {
        super();
        this.type = OutputReport2.MessageType.FIRMWARE_SIZE;
        this.totalBytes = 4;
    }

    set size(size: number) {
        this.setUint32(2, size, true);
    }

    get size() {
        return this.getUint32(2, true);
    }

    public withSize(size: number) {
        this.size = size;
        return this;
    }

    override logMessage() {
        return `FirmwareSizeMessage: ${this.size}`;
    }
}
